import { renderChildren } from "@booking/utils/helpers";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";

import Picture, {
  type PictureProps,
} from "@/components/molecules/media/Picture";
import { createId } from "@/utils/helpers";

import styles from "./Figure.module.css";

const ref = "figure";

interface FigureProps extends Partial<Pick<PictureProps, "image">> {
  captionClassName?: string;
  children?: React.ReactNode;
  className?: string;
  href?: string;
  imageClassName?: string;
  landscape?: boolean;
  opaque?: boolean;
  target?: string;
  transparent?: boolean;
}

function useFigure(props: FigureProps) {
  const { image, target = "_self", ...rest } = props;
  const className = clsx(
    styles[ref],
    props.opaque && styles.opaque,
    props.landscape && styles.landscape,
    props.transparent && "transparent",
    props.className,
  );
  const id = createId(ref);
  const picture = image ? (
    <Picture className={props.imageClassName} image={image} />
  ) : null;

  return {
    className,
    id,
    picture,
    target,
    ...rest,
  };
}

function Figure(props: FigureProps) {
  const { className, id, picture, target, ...rest } = useFigure(props);
  const { captionClassName, children, href } = props;

  return (
    <figure className={className}>
      {children && (
        <figcaption className={captionClassName}>
          {renderChildren(id, children)}
        </figcaption>
      )}

      {href && picture ? (
        <Link to={href} target={target} {...rest}>
          {picture}
        </Link>
      ) : (
        picture
      )}
    </figure>
  );
}

export default Figure;
export { Figure, type FigureProps };
